import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-ids-cockroach";
import { ProcessingActionType } from "@redotech/redo-model/return-flow/processing-action";
import {
  processingEventTypes,
  ProcessingStepDataType,
} from "@redotech/redo-return-warehouse-processing-db/processing-types";
import * as z from "zod";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  ProcessingEventType,
  processingEventTypes,
  ProcessingStepDataType,
  ProcessingStepRule,
  processingStepTypes,
  RuleOutcome,
  ruleOutcomes,
} from "@redotech/redo-return-warehouse-processing-db/processing-types";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type {
  ProcessingStepType,
  RuleOutcome as RuleOutcomeType,
} from "@redotech/redo-return-warehouse-processing-db/processing-types";

const NonActionStepDataSchema_ = z.object({
  step: z.enum([
    ProcessingStepDataType.PROCESSING_DECISION,
    ProcessingStepDataType.SORT,
    ProcessingStepDataType.LICENSE_PLATE,
    ProcessingStepDataType.EVIDENCE,
    ProcessingStepDataType.INFORMATION,
    ProcessingStepDataType.VERIFICATION,
    ProcessingStepDataType.VERIFY_ITEM_VARIANT,
  ]),
  rule: z.string().optional(),
  decision: z.boolean().optional(),
  notes: z.string().optional(),
  photos: z.array(z.string()).optional(),
});

const ProcessingActionStepDataSchema_ = z.object({
  step: z.literal(ProcessingStepDataType.PROCESSING_ACTION),
  actionType: z.literal(ProcessingActionType.AssignGrade),
  grade: z.string().min(1),
});

const ProcessingStepDataSchema_ = z.discriminatedUnion("step", [
  NonActionStepDataSchema_,
  ProcessingActionStepDataSchema_,
]);

export const ProcessingStepDataSchema: z.ZodType<ProcessingStepData> =
  ProcessingStepDataSchema_;
export type ProcessingStepData = z.infer<typeof ProcessingStepDataSchema_>;

export const logProcessingEvent = {
  name: "logProcessingEvent" as const,
  input: z.object({
    type: z.enum(processingEventTypes),
    sessionId: processingSessionIdFormat.schema,
    sessionItemId: processingSessionItemIdFormat.schema.optional(),
    flowId: z.string().optional(),
    flowStepId: z.string().optional(),
    data: z.record(z.string(), z.unknown()).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
